import { globalActor } from "../../state/GlobalContextProvider";
import { useRef, useEffect, useState } from "react";

import { useSelector } from "@xstate/react";
export default function PlaceScreen() {
  const t = useRef();
  const hasPlaced = useSelector(
    globalActor,
    (snapshot) => snapshot.context.hasPlaced
  );
  const started = useSelector(
    globalActor,
    (snapshot) => snapshot.context.started
  );
  const [showInst, setShowInst] = useState(!hasPlaced);

  useEffect(() => {
    if (started) {
      t.current = setTimeout(() => {
        // setShowInst(false);
      }, 5000);
    }

    return (_) => {
      clearTimeout(t.current);
    };
  }, [started]);
  // const showInst = true;
  // const started = true;
  return (
    <div
      className="Screen Place"
      onClick={(_) => {
        globalActor.send({ type: "PLACE" });
      }}
    >
      <div
        className={started && showInst ? "Instructions Active" : "Instructions"}
      >
        Indication, Important
        <br />
        Safety Information,
        <br />
        References
      </div>

      <button
        onClick={(_) => {
          globalActor.send({ type: "PLACE" });
        }}
      >
        Tap to place
      </button>
    </div>
  );
}
